// extracted by mini-css-extract-plugin
export default {"advtWrapper":"Advt_advtWrapper__v4DBO","title":"Advt_title__xcUWw"};